/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".cart[_ngcontent-%COMP%]   .fa[_ngcontent-%COMP%]{font-size:18px}.cart[_ngcontent-%COMP%]{display:inline-block;position:relative}.cart_count[_ngcontent-%COMP%]{align-items:center;background-color:#000;border-radius:50%;color:#fff;display:flex;font-size:8px;font-weight:700;height:14px;justify-content:center;position:absolute;right:-10px;top:-8px;width:14px}\n/*# sourceMappingURL=machine.component.css.map*/"];
export { styles as styles };
